// extracted by mini-css-extract-plugin
module.exports = {"tourist":"tourist_tourist__WCszZ","imageWrap":"tourist_imageWrap__1TsLQ","bdiImage4":"tourist_bdiImage4__F0H0i","desc":"tourist_desc__3LhDr","subDesc":"tourist_subDesc__2vQCT"};